module.exports = __webpack_public_path__ + "static/media/arrow-alt-square-left.91d40db0.svg";